import * as React from "react";
import classnames from "classnames";
import { Price, Button, toast } from "@grandvisionhq/common";
import { Divider } from "@grandvisionhq/elements";
import { CheckboxWithLabel } from "@grandvisionhq/forms";
import { Icon } from "@grandvisionhq/icons";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css                    */
const LineItemUpsell = ({
  labels,
  currency,
  sku,
  hasImplicitTermsAndConditions = false,
  value,
  onTermsAndConditionsChange,
  handleOpenModal,
  handleAddToCart,
  isChecked = false,
  errorMessageKey,
  analyticsData
}) => {
  const [shouldShowError, setShouldShowError] = React.useState(false);
  const handleConsentChange = ({ checked }) => {
    onTermsAndConditionsChange?.(checked);
    setShouldShowError(!checked);
  };
  const handleClick = () => {
    if (!hasImplicitTermsAndConditions && !isChecked) {
      setShouldShowError(true);
      errorMessageKey && toast.failed(errorMessageKey);
      return;
    }
    handleAddToCart?.(sku);
  };
  return /* @__PURE__ */ React.createElement("aside", { className: "card-section line-item-upsell" }, /* @__PURE__ */ React.createElement("div", { className: "line-item-upsell__header" }, /* @__PURE__ */ React.createElement(Text, { component: "h3", variant: "body-head" }, labels.title), /* @__PURE__ */ React.createElement(
    Text,
    {
      variant: "body-head",
      className: classnames("line-item-upsell__header-price", {
        "line-item-upsell__header-price--green": !value
      })
    },
    value ? /* @__PURE__ */ React.createElement(React.Fragment, null, "+", " ", /* @__PURE__ */ React.createElement(Price, { value, currency })) : labels.free
  )), /* @__PURE__ */ React.createElement("div", { className: "line-item-upsell__content" }, /* @__PURE__ */ React.createElement("div", { className: "line-item-upsell__usps" }, /* @__PURE__ */ React.createElement("ul", { className: "line-item-upsell__usps-list" }, labels.uspList.map((usp, index) => /* @__PURE__ */ React.createElement("li", { key: index }, /* @__PURE__ */ React.createElement(Icon, { name: "checkmark-circle", height: 16, width: 16 }), /* @__PURE__ */ React.createElement(Text, { variant: "body-head", component: "span" }, usp)))), Boolean(handleOpenModal) && /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "ghost",
      onClick: handleOpenModal,
      size: "small",
      caption: labels.moreAbout
    }
  ), !hasImplicitTermsAndConditions && /* @__PURE__ */ React.createElement(Divider, { theme: "light" })), Boolean(handleAddToCart) && /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "line-item-upsell__cta",
      caption: labels.add,
      "aria-label": labels.add,
      variant: "outline",
      size: "small",
      onClick: handleClick,
      ...analyticsData?.button?.dataElementId && {
        "data-element-id": analyticsData.button.dataElementId
      },
      ...analyticsData?.button?.dataDescription && {
        "data-description": analyticsData.button.dataDescription
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "termsAndConditions" }, hasImplicitTermsAndConditions ? /* @__PURE__ */ React.createElement(Text, { variant: "body" }, labels.implicitTermsAndAgreementLabel) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, { variant: "body" }, labels.explicitTermsAndAgreementLabel), /* @__PURE__ */ React.createElement(
    CheckboxWithLabel,
    {
      "data-t": "consent",
      label: labels.consent,
      onChange: handleConsentChange,
      value: "consent",
      checked: isChecked,
      errorMessage: labels.errorMessage,
      error: shouldShowError
    }
  )))));
};
export {
  LineItemUpsell
};
//# sourceMappingURL=LineItemUpsell.js.map
